// UPDATED MobileActionBar.jsx - Add this to your MobileActionBar component file:

import { 
    Paper, 
    Box, 
    Button, 
    FormControl, 
    Select, 
    MenuItem, 
    Badge,
    useTheme,
    useMediaQuery
  } from '@mui/material';
  import {
    FilterList as FilterListIcon,
    Map as MapIcon,
    Search as SearchIcon,
    AddBusiness as AddBusinessIcon
  } from '@mui/icons-material';
  
  const MobileActionBar = ({ 
    onFilterClick, 
    sortBy, 
    setSortBy, 
    showMap, 
    setShowMap, 
    hasActiveFilters,
    SORT_OPTIONS,
    // Add these new props
    handleFindBusiness,
    handleAddBusiness
  }) => {
    const theme = useTheme();
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
    return (
      <>
        {/* Top Row - Find/Add Business Buttons */}
        <Paper 
          elevation={1}
          sx={{ 
            mb: 1,
            borderRadius: 2,
            p: 1.5
          }}
        >
          <Box sx={{ 
            display: 'flex', 
            gap: 1,
            justifyContent: 'center'
          }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={handleFindBusiness}
              size={isSmallMobile ? "small" : "medium"}
              sx={{ 
                flex: 1,
                fontSize: isSmallMobile ? '0.75rem' : '0.875rem'
              }}
            >
              {isSmallMobile ? 'Find' : 'Find Businesses'}
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddBusinessIcon />}
              onClick={handleAddBusiness}
              size={isSmallMobile ? "small" : "medium"}
              sx={{ 
                flex: 1,
                fontSize: isSmallMobile ? '0.75rem' : '0.875rem'
              }}
            >
              {isSmallMobile ? 'Add' : 'Add Business'}
            </Button>
          </Box>
        </Paper>
  
        {/* Bottom Row - Filter/Map/Sort Controls */}
        <Paper 
          elevation={2}
          sx={{ 
            position: 'sticky',
            top: 0,
            zIndex: 10,
            mb: 2,
            borderRadius: 2
          }}
        >
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            p: 1.5,
            gap: 1
          }}>
            {/* Left Side - Filter and Map buttons */}
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant={hasActiveFilters ? 'contained' : 'outlined'}
                size="small"
                onClick={onFilterClick}
                startIcon={
                  <Badge 
                    color="primary" 
                    variant="dot" 
                    invisible={!hasActiveFilters}
                  >
                    <FilterListIcon />
                  </Badge>
                }
                sx={{ minWidth: 'auto', px: 1.5 }}
              >
                Filter
              </Button>
              
              <Button
                variant={showMap ? 'contained' : 'outlined'}
                size="small"
                onClick={() => setShowMap(!showMap)}
                startIcon={<MapIcon />}
                sx={{ minWidth: 'auto', px: 1.5 }}
              >
                Map
              </Button>
            </Box>
  
            {/* Right Side - Sort dropdown */}
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Sort search results by' }}
              >
                {SORT_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Paper>
      </>
    );
  };
  
  export default MobileActionBar;